import React from 'react';
import { motion } from 'framer-motion';
import { FaReact, FaNodeJs, FaHtml5, FaCss3Alt, FaGithub, FaDatabase, FaPython, FaGitAlt, FaRobot, FaTerminal, FaJira } from 'react-icons/fa';
import { SiFirebase } from 'react-icons/si';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: "Frontend Engineering",
      color: "var(--accent-1)",
      skills: [
        { name: "React.js", icon: <FaReact color="#61DAFB" /> },
        { name: "Next.js", icon: <FaReact color="#ffffff" /> },
        { name: "JavaScript", icon: <FaHtml5 color="#F7DF1E" /> },
        { name: "HTML5 & CSS3", icon: <FaCss3Alt color="#1572B6" /> },
        { name: "Tailwind CSS", icon: <FaCss3Alt color="#38B2AC" /> }
      ]
    },
    {
      title: "Backend & Database",
      color: "var(--accent-2)",
      skills: [
        { name: "Node.js", icon: <FaNodeJs color="#339933" /> },
        { name: "Python", icon: <FaPython color="#3776AB" /> },
        { name: "Firebase", icon: <SiFirebase color="#FFCA28" /> },
        { name: "MongoDB", icon: <FaDatabase color="#47A248" /> },
        { name: "MySQL", icon: <FaDatabase color="#4479A1" /> }
      ]
    },
    {
      title: "AI & Tools",
      color: "var(--accent-3)",
      skills: [
        { name: "Langchain", icon: <FaRobot color="#ffffff" /> },
        { name: "Claude Code", icon: <FaTerminal color="#A371F7" /> },
        { name: "Git & GitHub", icon: <FaGitAlt color="#F05032" /> },
        { name: "Jira", icon: <FaJira color="#0052CC" /> },
        { name: "Vercel", icon: <FaReact color="#ffffff" /> }
      ]
    }
  ];

  return (
    <section id="skills" className="section skills">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="section-title text-gradient-accent">Technical Arsenal</h2>
          <div className="title-underline"></div>
        </motion.div>

        <div className="skills-container">
          {skillCategories.map((category, idx) => (
            <motion.div 
              key={idx} 
              className="skill-category glass-panel hover-target"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15, duration: 0.6 }}
            >
              <h3 style={{ borderBottomColor: category.color }}>{category.title}</h3>
              <div className="skill-tags">
                {category.skills.map((skill, index) => (
                  <span key={index} className="skill-tag">
                    <span className="skill-icon-wrapper">{skill.icon}</span>
                    {skill.name}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
